export default __webpack_public_path__ + "static/media/Icon material-error.594fa971.svg";